import { fields } from "./Component";
export default fields;
